import 'whatwg-fetch'
import { polyfill } from 'es6-promise'
import $ from 'jquery'
import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import App from '../vue/filterlist.vue'

polyfill()
window.$ = $
window.jQuery = $
window.Vue = Vue
Vue.use(TurbolinksAdapter)

document.addEventListener('turbolinks:load', mountFilterlist)
$(document).ready(mountFilterlist)

function mountFilterlist() {
  const element = document.getElementById('filterlist')
  if (element) {
    new Vue({
      el: element,
      render: createElement => createElement(App)
    })
  }
}
